import { DBAction } from '@/enumLocal/defaultProps';
import FullLayout from '@/layouts/full/FullLayout.vue';
import Dashboard from '@/views/dashboards/dashboard1/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { mainRoutesName } from './routeName';
import { lazyWithRetry } from './routerUtils';


const metaManager = {
    manager: true,
}

const MainRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        name: mainRoutesName.root,
        meta: {
            requiresAuth: true
        },
        redirect: { name: mainRoutesName.dashboard },
        component: FullLayout,
        children: [
            {
                name: mainRoutesName.dashboard,
                path: '/' + mainRoutesName.dashboard,
                component: Dashboard
                //component: { template: '<div style="padding:24px">DASHBOARD placeholder</div>' }
            },
            {
                name: mainRoutesName.home,
                path: '/' + mainRoutesName.home,
                component: Dashboard
            },
            {
                name: mainRoutesName.quoteManage,
                path: '/' + mainRoutesName.quoteManage,
                component: lazyWithRetry( () => import( '@/views/quote/quoteManage/QuoteManage.vue' ) )
            },
            {
                name: mainRoutesName.userList,
                path: '/' + mainRoutesName.userList,
                component: lazyWithRetry( () => import( '@/views/user/userList/UserList.vue' ) )
            },
            {
                name: mainRoutesName.companySettings,
                path: '/' + mainRoutesName.companySettings,
                component: lazyWithRetry( () => import( '@/views/settings/CompanySettings.vue' ) )
            },
            {
                name: mainRoutesName.accountSettings,
                path: '/' + mainRoutesName.accountSettings,
                component: lazyWithRetry( () => import( '@/views/settings/AccountSettings.vue' ) )
            },
            {
                name: mainRoutesName.companyList,
                path: '/' + mainRoutesName.companyList,
                component: lazyWithRetry( () => import( '@/views/company/companyList/CompanyList.vue' ) ),
                meta: metaManager
            },
            {
                name: mainRoutesName.productModelList,
                path: '/' + mainRoutesName.productModelList,
                component: lazyWithRetry( () => import( '@/views/product/productModelList/ProductModelList.vue' ) ),
                meta: metaManager
            },
            {
                name: mainRoutesName.pantoneList,
                path: '/' + mainRoutesName.pantoneList,
                component: lazyWithRetry( () => import( '@/views/pantone/pantoneList/PantoneList.vue' ) ),
                meta: metaManager
            },
            {
                name: mainRoutesName.optionalList,
                path: '/' + mainRoutesName.optionalList,
                component: lazyWithRetry( () => import( '@/views/optional/optionalList/OptionalList.vue' ) ),
                meta: metaManager
            },
            {
                name: mainRoutesName.accessoryList,
                path: '/' + mainRoutesName.accessoryList,
                component: lazyWithRetry( () => import( '@/views/optional/accessoryList/AccessoryList.vue' ) ),
                meta: metaManager
            },
            {
                name: mainRoutesName.measureGroupList,
                path: '/' + mainRoutesName.measureGroupList,
                component: lazyWithRetry( () => import( '@/views/measure/measureGroupList/MeasureGroupList.vue' ) ),
                meta: metaManager
            },
            {
                name: mainRoutesName.priceList,
                path: '/' + mainRoutesName.priceList,
                component: lazyWithRetry( () => import( '@/views/price/priceList/PriceList.vue' ) ),
                meta: metaManager
            },
            {
                name: mainRoutesName.superAdmin,
                path: '/' + mainRoutesName.superAdmin,
                component: lazyWithRetry( () => import( '@/views/superAdmin/superAdminList/SuperAdminList.vue' ) )
            },
            {
                name: mainRoutesName.registry,
                path: '/' + mainRoutesName.registry,
                component: lazyWithRetry( () => import( '@/views/registry/registryList/RegistryList.vue' ) )
            },
            {
                name: mainRoutesName.mutateRegistry,
                path: '/' + mainRoutesName.mutateRegistry,
                component: lazyWithRetry( () => import( '@/views/registry/registryMutate/RegistryMutate.vue' ) )
            },
            {
                name: mainRoutesName.quoteList,
                path: '/' + mainRoutesName.quoteList,
                component: lazyWithRetry( () => import( '@/views/quote/quoteList/QuoteList.vue' ) )
            },
            {
                name: mainRoutesName.mutateQuote,
                path: '/' + mainRoutesName.mutateQuote + '/:idQuote',
                component: lazyWithRetry( () => import( '@/views/quote/quoteMutate/QuoteMutate.vue' ) ),
                props: {
                    action: DBAction.EDIT,
                    isPopup: false
                },
            },
            {
                name: mainRoutesName.viewQuote,
                path: '/' + mainRoutesName.viewQuote + '/:idQuote',
                component: lazyWithRetry( () => import( '@/views/quote/quoteMutate/QuoteMutate.vue' ) ),
                props: {
                    action: DBAction.VIEW,
                    isPopup: false
                },
            },
            {
                name: mainRoutesName.newQuote,
                path: '/' + mainRoutesName.newQuote,
                component: lazyWithRetry( () => import( '@/views/quote/quoteMutate/QuoteMutate.vue' ) ),
                props: {
                    action: DBAction.CREATE,
                    isPopup: false
                },

            }


        ]
    } ]
    ;

export default MainRoutes;
export { mainRoutesName };

